// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__RG0Py","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__buAAI"};